import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://plateforme.fhcgroupesarl.com/api';
const token = () => localStorage.getItem('fhc_token');

const PointageModule = ({ currentUser }) => {
  const [code, setCode] = useState('');
  const [message, setMessage] = useState(null);
  const [todayPointage, setTodayPointage] = useState(null);
  const [loading, setLoading] = useState(false);

  const currentTime = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const currentDate = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

  useEffect(() => {
    // Vérifier si l'employé a déjà pointé aujourd'hui via l'API
    fetch(`${API}/pointage/code-jour`, {
      headers: { Authorization: `Bearer ${token()}` }
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data?.pointage_today) setTodayPointage(data.pointage_today);
      })
      .catch(() => {});
  }, []);

  const validerPresence = () => {
    if (!code.trim()) {
      setMessage({ type: 'error', text: 'Veuillez entrer le code du jour' });
      return;
    }
    setLoading(true);

    fetch(`${API}/pointage/verifier`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token()}`
      },
      body: JSON.stringify({ code: code.trim() })
    })
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (ok) {
          const p = { heure: data.heure, statut: data.statut };
          setTodayPointage(p);
          setMessage({
            type: 'success',
            text: data.statut === 'ok'
              ? `✅ Présence validée à ${data.heure}`
              : `⏰ Présence validée à ${data.heure} (Retard - limite 8h30)`
          });
          setCode('');
        } else {
          setMessage({ type: 'error', text: data.message || 'Code incorrect' });
        }
      })
      .catch(() => setMessage({ type: 'error', text: 'Erreur de connexion au serveur' }))
      .finally(() => setLoading(false));
  };

  // État validé
  if (todayPointage) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, rgba(17,31,48,0.95) 0%, rgba(13,24,37,0.95) 100%)',
        border: '1px solid rgba(201,168,76,0.2)',
        borderRadius: 16,
        padding: '24px 28px',
        marginBottom: 20,
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Effet brillant en arrière-plan */}
        <div style={{
          position: 'absolute',
          top: -50,
          right: -50,
          width: 200,
          height: 200,
          background: todayPointage.statut === 'ok' 
            ? 'radial-gradient(circle, rgba(67,160,71,0.15) 0%, transparent 70%)' 
            : 'radial-gradient(circle, rgba(251,140,0,0.15) 0%, transparent 70%)',
          borderRadius: '50%',
          pointerEvents: 'none'
        }} />

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          position: 'relative',
          zIndex: 1
        }}>
          {/* Icône de statut */}
          <div style={{
            width: 70,
            height: 70,
            borderRadius: '50%',
            background: todayPointage.statut === 'ok' 
              ? 'linear-gradient(135deg, #66bb6a 0%, #43a047 100%)' 
              : 'linear-gradient(135deg, #ffb74d 0%, #ff9800 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 32,
            boxShadow: todayPointage.statut === 'ok'
              ? '0 4px 20px rgba(67,160,71,0.4)'
              : '0 4px 20px rgba(251,140,0,0.4)',
            flexShrink: 0
          }}>
            {todayPointage.statut === 'ok' ? '✓' : '⏰'}
          </div>

          {/* Contenu */}
          <div style={{ flex: 1 }}>
            <div style={{
              fontSize: 11,
              color: '#C9A84C',
              fontWeight: 600,
              letterSpacing: 1.2,
              textTransform: 'uppercase',
              marginBottom: 6
            }}>
              ✓ Présence validée
            </div>
            <div style={{
              fontSize: 24,
              fontWeight: 700,
              fontFamily: "'Cormorant Garamond', serif",
              color: todayPointage.statut === 'ok' ? '#66bb6a' : '#ffb74d',
              marginBottom: 4,
              letterSpacing: 0.5
            }}>
              {todayPointage.heure}
            </div>
            <div style={{ 
              fontSize: 12, 
              color: '#889',
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}>
              <span>{todayPointage.statut === 'ok' ? '🟢' : '🟡'}</span>
              <span>
                {todayPointage.statut === 'ok' 
                  ? 'À l\'heure • Limite 8h30' 
                  : 'En retard • Limite dépassée'}
              </span>
            </div>
          </div>

          {/* Badge */}
          <div style={{
            padding: '8px 16px',
            borderRadius: 8,
            background: todayPointage.statut === 'ok' 
              ? 'rgba(67,160,71,0.15)' 
              : 'rgba(251,140,0,0.15)',
            border: `1px solid ${todayPointage.statut === 'ok' 
              ? 'rgba(67,160,71,0.3)' 
              : 'rgba(251,140,0,0.3)'}`,
            fontSize: 10,
            fontWeight: 700,
            color: todayPointage.statut === 'ok' ? '#66bb6a' : '#ffb74d',
            textTransform: 'uppercase',
            letterSpacing: 0.8,
            textAlign: 'center'
          }}>
            {todayPointage.statut === 'ok' ? 'Ponctuel' : 'Retard'}
          </div>
        </div>
      </div>
    );
  }

  // État en attente de validation
  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(17,31,48,0.98) 0%, rgba(13,24,37,0.98) 100%)',
      border: '1px solid rgba(201,168,76,0.2)',
      borderRadius: 16,
      padding: '28px 32px',
      marginBottom: 20,
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Effet de fond animé */}
      <div style={{
        position: 'absolute',
        top: -100,
        left: -100,
        width: 300,
        height: 300,
        background: 'radial-gradient(circle, rgba(201,168,76,0.08) 0%, transparent 70%)',
        borderRadius: '50%',
        pointerEvents: 'none'
      }} />

      <div style={{ position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 20
        }}>
          <div style={{ flex: 1 }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              marginBottom: 8
            }}>
              <div style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: 'linear-gradient(135deg, #C9A84C 0%, #8a6028 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 20,
                boxShadow: '0 4px 12px rgba(201,168,76,0.3)'
              }}>
                📍
              </div>
              <div>
                <div style={{
                  fontSize: 16,
                  fontWeight: 700,
                  fontFamily: "'Cormorant Garamond', serif",
                  color: '#fff',
                  letterSpacing: 0.5
                }}>
                  Pointage du jour
                </div>
                <div style={{ fontSize: 10, color: '#667', marginTop: 2 }}>
                  {currentDate}
                </div>
              </div>
            </div>
          </div>
          
          {/* Heure actuelle */}
          <div style={{
            padding: '8px 16px',
            borderRadius: 8,
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            fontSize: 18,
            fontWeight: 700,
            fontFamily: "'Courier New', monospace",
            color: '#C9A84C',
            letterSpacing: 1
          }}>
            {currentTime}
          </div>
        </div>

        {/* Formulaire */}
        <div style={{
          background: 'rgba(0,0,0,0.2)',
          border: '1px solid rgba(255,255,255,0.06)',
          borderRadius: 12,
          padding: 20
        }}>
          <label style={{
            fontSize: 11,
            color: '#C9A84C',
            textTransform: 'uppercase',
            letterSpacing: 1,
            fontWeight: 600,
            display: 'block',
            marginBottom: 10
          }}>
            Code du jour *
          </label>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && validerPresence()}
              placeholder="Entrez le code..."
              disabled={loading}
              style={{
                flex: 1,
                background: 'rgba(255,255,255,0.08)',
                border: '2px solid rgba(201,168,76,0.3)',
                borderRadius: 10,
                padding: '14px 16px',
                color: '#fff',
                fontSize: 16,
                fontWeight: 600,
                outline: 'none',
                textTransform: 'uppercase',
                letterSpacing: 2,
                textAlign: 'center',
                fontFamily: "'Courier New', monospace",
                transition: 'all 0.3s',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#C9A84C';
                e.target.style.boxShadow = '0 4px 16px rgba(201,168,76,0.2)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(201,168,76,0.3)';
                e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
              }}
            />
            <button
              onClick={validerPresence}
              disabled={loading}
              style={{
                background: loading 
                  ? 'rgba(201,168,76,0.3)' 
                  : 'linear-gradient(135deg, #C9A84C 0%, #8a6028 100%)',
                border: 'none',
                borderRadius: 10,
                padding: '14px 24px',
                color: '#fff',
                fontSize: 14,
                fontWeight: 700,
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s',
                boxShadow: loading ? 'none' : '0 4px 16px rgba(201,168,76,0.3)',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 6px 20px rgba(201,168,76,0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 16px rgba(201,168,76,0.3)';
                }
              }}
            >
              {loading ? '⏳ Validation...' : '✓ Valider'}
            </button>
          </div>

          {/* Message */}
          {message && (
            <div style={{
              marginTop: 12,
              padding: '12px 16px',
              borderRadius: 8,
              fontSize: 12,
              fontWeight: 600,
              background: message.type === 'success' 
                ? 'rgba(67,160,71,0.15)' 
                : 'rgba(229,57,53,0.15)',
              border: `1px solid ${message.type === 'success' 
                ? 'rgba(67,160,71,0.4)' 
                : 'rgba(229,57,53,0.4)'}`,
              color: message.type === 'success' ? '#66bb6a' : '#ef8080',
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}>
              <span style={{ fontSize: 16 }}>
                {message.type === 'success' ? '✓' : '✕'}
              </span>
              {message.text}
            </div>
          )}
        </div>

        {/* Info */}
        <div style={{
          marginTop: 16,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          fontSize: 11,
          color: '#667'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}>
            <span style={{ fontSize: 14 }}>⏰</span>
            <span>Limite : <strong style={{ color: '#C9A84C' }}>8h30</strong></span>
          </div>
          <span style={{ color: '#334' }}>•</span>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}>
            <span style={{ fontSize: 14 }}>🔒</span>
            <span>Validation unique par jour</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PointageModule;
